import Util from './Utils';
import Pref from "./Pref";
import {DEBUG} from "./Config";

export default class Api {

    static URL_BASE = DEBUG
        ? 'https://beta.toolrides.com/api'
        : '/api';

    static get(url, data, callback, loading) {

        if (typeof data === 'function') {
            loading = callback;
            callback = data;
            data = null;
        }

        if (typeof loading === 'undefined') {
            loading = true;
            Util.loading(true);
        } else if (loading) {
            Util.loading(loading);
        }

        if (data && typeof data === 'object') {
            const qs = new URLSearchParams();
            Object.entries(data).forEach(([k, v]) => {
                if (v !== undefined && v !== null) qs.append(k, v);
            });
            const sep = url.includes('?') ? '&' : '?';
            url = url + sep + qs.toString();
        }

        this.fetch(url, {method: 'GET'})
            .then(async res => {

                if (res.ok) {
                    let json = await res.json();

                    if (loading) Util.loading(false);
                    if (callback) callback(json);
                } else {
                    if (callback) callback({
                        ok: false, msg: res.statusText,
                    });
                }

            })
            .catch(err => {

                console.error('err', err);

                if (callback) callback({
                    ok: false, msg: err.message,
                });

            });
    }

    static post(url, data, callback, loading) {

        if (typeof data === 'function') {
            loading = callback;
            callback = data;
            data = {};
        }

        if (typeof loading === 'undefined') {
            loading = true;
            Util.loading(true);
        } else if (loading) {
            Util.loading(loading);
        }

        this.fetch(url, {
            method: 'POST',
            body  : JSON.stringify(data),
        })
            .then(async res => {

                if (res.ok) {
                    let json = await res.json();

                    if (loading) Util.loading(false);
                    if (callback) callback(json);
                } else {
                    if (callback) callback({
                        ok: false, msg: res.statusText,
                    });
                }

            })
            .catch(err => {

                console.error('err', err);

                if (callback) callback({
                    ok: false, msg: err.message,
                });

            });
    }

    static fetch(url, options = {}) {
        const headers = {
            'Authorization': `Bearer ${Pref.sessionToken}`,
            ...options.headers,
        };

        return fetch(`${Api.URL_BASE}${url}`, {
            ...options,
            headers,
        });
    }

}